<template>
  <CatalogCrudView
    title="Tipos de conta"
    subtitle="Classifique a natureza funcional das contas internas do ledger."
    singular="tipo de conta"
    list-title="Tipos de conta cadastrados"
    icon="wallet"
    search-placeholder="Nome, descrição ou código"
    :service="service"
    :fields="fields"
    :columns="columns"
    :form-defaults="formDefaults"
  />
</template>

<script>
import CatalogCrudView from '../components/CatalogCrudView.vue'
import service from '../services/accountTypeService'

export default {
  name: 'AccountTypesView',
  components: { CatalogCrudView },
  data: () => ({
    service,
    formDefaults: { name: '', description: '', code: '', isActive: true },
    fields: [
      { key: 'name', label: 'Nome', required: true, maxlength: 100, placeholder: 'Ex.: Conta bancária', span: 4 },
      { key: 'description', label: 'Descrição', required: true, maxlength: 100, placeholder: 'Descreva a finalidade da conta', span: 4 },
      { key: 'code', label: 'Código', required: true, maxlength: 30, placeholder: 'Ex.: BANK', uppercase: true, span: 2 },
      { key: 'isActive', label: 'Situação', type: 'select', span: 2, options: [{ value: true, label: 'Ativo' }, { value: false, label: 'Inativo' }] }
    ],
    columns: [
      { text: 'Id', value: 'id' }, { text: 'Nome', value: 'name', emphasis: true },
      { text: 'Descrição', value: 'description' }, { text: 'Código', value: 'code', type: 'code' },
      { text: 'Situação', value: 'isActive', type: 'status' }, { text: 'Criado em', value: 'createdAt', type: 'date' }
    ]
  })
}
</script>
